import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import auth from "./auth";
import { test_ip } from "../services/constants";
import Loading from "../components/Loading";

import { Dashen_Constants } from "../services/dashen_bank_constants";
import Button from "@mui/material/Button";
import { Alert } from "@mui/material";
import { check_error_code } from "../services/error_string";
const appCode = Dashen_Constants.MINI_APP_CODE;
const appSecret = Dashen_Constants.appSecret;
const base_url = Dashen_Constants.BASE_URL;

const Test = () => {
  const [customerIdentifier, setCustomerIdentifier] = useState(null);
  const [loading, setLoading] = useState();
  const [error, setError] = useState([]);
  const nav = useNavigate();
  const requestLocationPermission = () => {
    const fetchCurrentLocation = JSON.stringify({
      functionName: "fetchCurrentLocation",
      params: {
        callbackName: "handleLocationCallback",
      }, // Registering permission callback
    });

    if (window.dashenbanksuperapp) {
      window.dashenbanksuperapp.send(fetchCurrentLocation);
    } else {
      setError(["something went wrong......."]);
      // alert("Dashen Bank SuperApp is not available!!!!!!!!!!!!!");
    }
  };

  const fetchAccessToken = () => {
    const saRequestPayload = JSON.stringify({
      functionName: "fetchAccessToken",
      params: {
        appcode: appCode,
        callbackName: "DashenCallback",
      },
    });

    if (window.dashenbanksuperapp) {
      window.dashenbanksuperapp.send(saRequestPayload);
    } else {
      setError(["please check internet connection..."]);
    }
  };

  const DashenCallback = (identifier) => {
    setCustomerIdentifier(identifier);
  };

  const handleLocationCallback = (result) => {
    if (result) {
      localStorage.setItem("userLocation", JSON.stringify(result));
    } else {
      setError(["location permission rrequest denied..."]);
    }
  };

  useEffect(() => {
    window.handleLocationCallback = handleLocationCallback;
    window.DashenCallback = DashenCallback;
    requestLocationPermission();
  }, []);

  useEffect(() => {
    const requestFabricToken = async () => {
      if (customerIdentifier) {
        const body = JSON.stringify({
          appcode: appCode,
          stage: "uat",
          customeridentifier: customerIdentifier,
        });

        try {
          const res = await axios.post(
            base_url,
            // "https://sau.eaglelionsystems.com/v1.0/chatbirrapi/miniapps/apps/getfabrictoken",
            body,
            {
              headers: {
                "x-api-key": appSecret,
                "Content-Type": "application/json",
              },
            }
          );

          // console.log("Fabric Token Response:", res.data);
          if (res.data.data && res.data.data.customer) {
            const { name, phoneNumber } = res.data.data.customer;
            const secondBody = JSON.stringify({
              name: name,
              phone: phoneNumber,
            });

            const secondRes = await axios.post(
              `${test_ip}api/user/login_with_dashen_supperapp`,
              secondBody,
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );

            if (secondRes.data.success) {
              const user_data = {
                user_id: secondRes.data.user._id,
                unique_id: secondRes.data.user.unique_id,
                cart_id: secondRes.data.user.cart_id,
                phone: secondRes.data.user.phone,
                last_name: secondRes.data.user.last_name,
                first_name: secondRes.data.user.first_name,
                email: secondRes.data.user.email,
                country_id: secondRes.data.user.country_id,
                server_token: secondRes.data.user.server_token,
                order_count: secondRes.data.user.order_count,
                token: res.data.token, // token from Dashen SuperApp
              };

              localStorage.setItem("user", JSON.stringify(user_data));
              auth.login(() => {
                nav("/home", { replace: true });
              });
            } else {
              const message = check_error_code(secondRes.data.error_code);
              setError([message]);
            }
          }
        } catch (err) {
          // alert("Error during Fabric Token request");
          setError(["please check internet connection..."]);
        } finally {
          setLoading(false);
        }
      }
    };

    if (customerIdentifier) {
      requestFabricToken(); // Call the function to request token
    }
  }, [customerIdentifier]);

  const handleLoginClick = async () => {
    setLoading(true);
    const storedLocation = JSON.parse(localStorage.getItem("userLocation"));
    const lat = storedLocation.latitude;
    const lon = storedLocation.longitude;
    if (!lat || !lon) {
      requestLocationPermission(); // If not, request permission
      return; // Exit the function early if location is not available
    }
    fetchAccessToken();
  };

  return (
    <div
      className="b-login-page"
      style={{
        display: "flex", // Use Flexbox
        justifyContent: "center", // Center horizontally
        alignItems: "center",
        width: "100vw", // 100% of the viewport width
        height: "100vh", // 100% of the viewport height
        backgroundColor: "white",
        // Your desired background color
      }}
    >
      <div className="b-contain">
        <div className="b-logo" style={{ width: "100%" }}>
          <img
            style={{
              display: "block",
              width: "80px",
              borderRadius: "50%",
              marginBottom: "20px",
              marginLeft: "auto",
              marginRight: "auto",
            }}
            src="zmall-logo.png"
            alt="zmall-logo"
          />
        </div>
        <div className="b-b-btn">
          <h4>
            Please login using Dashen super App to use ZMall Delivery. By
            pressing the Login button, you are allowing permission to use your
            phone number and name!..
          </h4>
        </div>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Loading />
          </div>
        ) : (
          <Button
            className="b-login-btn"
            size="small"
            onClick={handleLoginClick}
          >
            Login
          </Button>
        )}
        {/* <Button className="b-login-btn" size="small" onClick={handleLoginClick}>
          Login
        </Button> */}
      </div>
    </div>
  );
};

export default Test;
